module.exports = __webpack_public_path__ + "static/media/RightToCorrectForm_QCPP_EN.f5d440e8.pdf";